/**
 * Loading spinner with size variants.
 */

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'h-4 w-4 border',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-2',
};

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  return (
    <div
      data-testid="spinner"
      role="status"
      aria-label="Loading"
      className={`animate-spin rounded-full border-accent border-t-transparent ${sizeMap[size]} ${className}`}
    />
  );
}
